

import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, Link } from "react-router-dom";


import {

    categoriesAdd,
    updateCategories,
    fetchGalleryImageUpdate,
    getCategorybyId
} from "../../services/userservice";

import { setEditingCategory, setEditingCategoryId, setError, setLoading } from "../../features/common/categorySlice";

const AddCategory = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isEditMode, setIsEditMode] = useState(false);
    const { loading, error, editingCategory } = useSelector((state) => state.category);
    const [formData, setFormData] = useState([
        {
            name: "", image_url: "", status: ""
        },
    ]);

    const [imageURL, setImageURL] = useState(formData?.image_url)
    const [imageURLUploded, setImageURLUploded] = useState(null)

    console.log("formData", formData?.image_url)

    useEffect(() => {
        if (id && id !== "add" && editingCategory !== id) {
            dispatch(setEditingCategoryId(id));
            dispatch(setEditingCategory(id));
            setIsEditMode(true);
            fetchUserData(id);
        }
    }, [id, editingCategory, dispatch]);

    const fetchUserData = async (id) => {
        try {
            dispatch(setLoading());
            const response = await getCategorybyId(id);
            if (response) {
                const responseData = response;
                console.log("responseData,", responseData?.image_url)
                setFormData({
                    name: responseData?.name,
                    image_url: responseData?.image_url,
                    status: responseData?.status
                });
                setImageURL(responseData?.image_url || [])
                dispatch(setLoading(false));
            }
        } catch (error) {
            dispatch(setError(error.message));
        } finally {
            dispatch(setLoading(false));
        }
    };

    console.log("imageURL", imageURL)

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const formDataToSend = {
                ...formData,
                image_url: imageURL?.[0]?.image_url,
                thumbnail_image_url: imageURL?.[0]?.thumbnail_image_url
            };
            dispatch(setLoading(true));
            const response =
                id && id !== "add"
                    ? await updateCategories(id, formDataToSend)
                    : await categoriesAdd(formDataToSend);
            navigate("/category-list");
            console.log("response", response)
        } catch (error) {
            dispatch(setError(error.message));
            alert(error.message);

            dispatch(setLoading(false));
        }
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: name === "name" ? value : value,
        }));
    };


    useEffect(() => {
        if (Array.isArray(formData.image_url)) {
            setImageURL(formData.image_url);
        }
    }, [formData.image_url]);


    const handleGalleryChange = async (e) => {
        const files = Array.from(e.target.files);
        const formData = new FormData();

        files.forEach((file) => {
            formData.append('profile_pic', file);
            formData.append('type', "banner");
        });

        try {
            const response = await fetchGalleryImageUpdate(formData);
            console.log("fetchGalleryImageUpdate", response?.data?.files)
            // setImageURL(response?.data?.files?.[0]?.image_url)
            setImageURL(response?.data?.files)
            console.log("Image upload successful:", response?.data?.files?.[0]?.image_url);
        } catch (error) {
            console.error("Error uploading image:", error);
        }
    };
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Add Category  </h1>
                        </div>
                        {/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item active">Category</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div classname="row">
                        <div className="col-md-12">
                            <form onSubmit={handleSubmit}>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Category</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="exampleInputEmail1"
                                                        placeholder="Enter Category Name"
                                                        name="name"
                                                        value={formData.name}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label>STATUS</label>
                                                    <select
                                                        className="form-control"
                                                        id="status"
                                                        name="status"
                                                        value={formData.status}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="active">ACTIVE</option>
                                                        <option value="inactive">INACTIVE</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-sm-12">
                                                <div className="form-group">
                                                    <label>Image (Upload Images)</label>
                                                    <input
                                                        type="file"
                                                        multiple
                                                        className="form-control"
                                                        onChange={handleGalleryChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">

                                                {imageURL && imageURL?.length > 0 ? (
                                                    <>
                                                        <label>Uploaded Image</label>
                                                        <br />

                                                        {/* {imageURL?.map((img, index) => ( */}
                                                        {/* <div className="col-sm-3" key={index}> */}
                                                        <img
                                                            src={imageURL?.[0]?.image_url || imageURL}
                                                            style={{ width: "100%", borderRadius: '10px' }}
                                                        />
                                                        {/* </div> */}
                                                        {/* ))} */}

                                                    </>
                                                ) : null}



                                            </div>

                                        </div>


                                    </div>
                                    <div class="card-footer">
                                        <button type="submit" className="btn btn-primary">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddCategory;
